/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GraphTrendIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Graph Trend',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m33.093 6.061-8.14 11.374L20.9 9.321a.5.5 0 0 0-.917.053l-5.45 14.992-4.081-4.081a.5.5 0 0 0-.674-.031L2.18 26.579a.5.5 0 0 0-.18.384v4.188a.5.5 0 0 0 .829.376l7.048-6.157 5.708 5.708a.5.5 0 0 0 .823-.183l4.548-12.51L24 24.481a.5.5 0 0 0 .857.063l9.053-12.928a.5.5 0 0 0 .09-.286V6.352a.5.5 0 0 0-.907-.291Z"
    />
  </svg>`;
};
